module.exports = __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm-082bb3b44abbcfaf7c96c7afebc4440b.webp";